import userApi from '@/api/userApi'

const SET_USER_LIST = 'setUserList'
const SET_USER_COUNT = 'setUserCount'

const SET_AREA_LIST = 'setAreaList'
const SET_AREA_COUNT = 'setAreaCount'

const SET_STORE_LIST = 'setStoreList'
const SET_STORE_COUNT = 'setStoreCount'

const state = {
  userList: [],
  userCount: 0,

  areaList: [],
  areaCount: 0,

  storeList: [],
  storeCount: 0
}

const mutations = {
  [SET_USER_LIST] (state, userList) {
    state.userList = userList
  },
  [SET_USER_COUNT] (state, userCount) {
    state.userCount = userCount
  },

  [SET_AREA_LIST] (state, areaList) {
    state.areaList = areaList
  },
  [SET_AREA_COUNT] (state, areaCount) {
    state.areaCount = areaCount
  },

  [SET_STORE_LIST] (state, storeList) {
    state.storeList = storeList
  },
  [SET_STORE_COUNT] (state, storeCount) {
    state.storeCount = storeCount
  }
}

const actions = {
  getUsers ({ commit }, data) {
    return new Promise((resolve, reject) => {
      userApi.getUsers(data.page, data.pageSize, data.sort, data.filters).then(res => {
        if (res && res.rcode === 0) {
          commit(SET_USER_LIST, res.data.users)
          commit(SET_USER_COUNT, res.data.count)
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getAreas ({ commit }, data) {
    return new Promise((resolve, reject) => {
      userApi.getAreas(data.page, data.pageSize,
        data.sort, data.filters).then(res => {
        if (res && res.rcode === 0) {
          commit(SET_AREA_LIST, res.data.areas)
          commit(SET_AREA_COUNT, res.data.count)
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getStores ({ commit }, data) {
    return new Promise((resolve, reject) => {
      userApi.getStores(data.page, data.pageSize,
        data.sort, data.filters).then(res => {
        if (res && res.rcode === 0) {
          commit(SET_STORE_LIST, res.data.stores)
          commit(SET_STORE_COUNT, res.data.count)
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js